import { render, staticRenderFns } from "./QueueCardContainer.vue?vue&type=template&id=7a48880c&scoped=true&"
import script from "./QueueCardContainer.vue?vue&type=script&lang=js&"
export * from "./QueueCardContainer.vue?vue&type=script&lang=js&"
import style0 from "./QueueCardContainer.vue?vue&type=style&index=0&id=7a48880c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48880c",
  null
  
)

export default component.exports